module.exports = __webpack_public_path__ + "static/img/ID.53c334d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/ID.svg
// module id = 7QIk
// module chunks = 55